import React from "react";
import {
  StyledDialog,
  DialogContent,
  IconWrapper,
  SuccessTitle,
  SuccessDescription,
  DialogFooter,
  AddMoreButton,
  GoToVaultButton,
  UsersContainer,
  UserName,
} from "./SuccessShareVaultFileModal.styled";
import { CheckCircleOutline } from "@mui/icons-material";

const SuccessShareVaultFileModal = ({ isOpen, onClose, usersCount, vaultName, onAddMore, onGoToVault, users = [], onReload }) => {
  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleAddMore = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (onReload) {
      await onReload();
    }
    onAddMore();
  };

  const handleGoToVault = (e) => {
    e.preventDefault();
    e.stopPropagation();
    onGoToVault();
  };

  return (
    <StyledDialog 
      open={isOpen} 
      onClose={onClose}
      onClick={handleClick}
      sx={{
        '& .MuiDialog-container': {
          '& .MuiPaper-root': {
            maxWidth: '100%',
            margin: '16px'
          }
        }
      }}
    >
      <DialogContent onClick={handleClick}>
        <IconWrapper>
          <CheckCircleOutline color="success" sx={{ fontSize: 32 }} data-testid="success-icon"  />
        </IconWrapper>
        <SuccessTitle data-testid="success-modal">
          Your file has been successfully shared
        </SuccessTitle>
        <SuccessDescription data-testid="success-message">
          {usersCount} users have been added to {vaultName}
        </SuccessDescription>
        {users.length > 0 && (
          <UsersContainer>
            {users.map((user, index) => ( 
              <UserName key={index} index={index}>{user.name}</UserName>
            ))}
          </UsersContainer>
        )}
      </DialogContent>
      <DialogFooter>
        <AddMoreButton onClick={handleAddMore}>
          Add more users
        </AddMoreButton>
        <GoToVaultButton onClick={handleGoToVault}>
          Go to File detail
        </GoToVaultButton>
      </DialogFooter>
    </StyledDialog>
  );
};

export default SuccessShareVaultFileModal; 